import { Store } from 'flux/utils';
import RoleRequirementDispatcher from '../dispatchers/RoleRequirementDispatcher';

class RoleRequirementStore extends Store<{}> {
  private roleRequirements: RoleRequirement[] = [];

  getRoleRequirements(): RoleRequirement[] {
    return this.roleRequirements;
  }

  __onDispatch(payload: DispatchPayload) {
    if (payload.source === 'UPDATE_ROLE_REQUIREMENTS') {
      this.roleRequirements = payload.output.map((r: RoleRequirement) => {
        return {
          term: r.term.trim(),
          role: r.role.trim(),
          days: r.days,
        };
      });
      this.__emitChange();
    }
  }
}

const instance = new RoleRequirementStore(RoleRequirementDispatcher);
export default instance;



// WEBPACK FOOTER //
// ./src/stores/RoleRequirementStore.ts